export default {"src":"/_next/static/media/nubrakes-logo@white.4812fe52.svg","height":50,"width":322};